import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderGameSelectorComponent } from './slider-game-selector/slider-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { SliderGameCoreService } from './slider-game-core.service';

@NgModule({
  declarations: [SliderGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [SliderGameCoreService],
  exports: [SliderGameSelectorComponent],
})
export class SliderGameCoreModule {}
